import { IFeaturedVideoProps } from '../types'
import { getYouTubeEmbedUrl } from '../utils/get-youtube-embed-url'

export const FeaturedVideo = ({
  url,
  title,
}: IFeaturedVideoProps): JSX.Element | null => {
  const embedUrl = getYouTubeEmbedUrl(url)

  if (!embedUrl) {
    return null
  }

  return (
    <div className="aspect-[33/20] w-full overflow-hidden rounded-[14px] bg-content-primary">
      <iframe
        src={embedUrl}
        title={title}
        className="h-full w-full"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}
